import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import TicketSolds from './TicketSolds'
import * as action from '../../../../actions/ticketSoldAction'

const mapStateToProps = state => {
    return {
        ticketSoldState: state.ticketSoldReducer,
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        getListTicketSold: (filters) => dispatch(action.getTicketSold(filters))
    }
};

export default withTranslation()(connect(mapStateToProps, mapDispatchToProps)(TicketSolds));
